import { useCallback, useState } from 'react';
import { FileRejection, useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import useNotification from 'hooks/useNotification';
import store from 'store';

const MAX_FILE_SIZE = 5;

export default () => {
	const { t } = useTranslation();
	const showNotification = useNotification();

	const [isDragOver, setIsDragOver] = useState(false);

	const onDrop = useCallback(async (acceptedFiles: File[], fileRejections: FileRejection[]) => {
		setIsDragOver(false);

		if (fileRejections.length > 0) {
			fileRejections.forEach((fileRejection) => {
				fileRejection.errors.forEach((error) => {
					if (error.code === 'file-too-large') {
						showNotification('error', t('profile.maxSizeAvatarError', { size: MAX_FILE_SIZE }));
					} else if (error.code === 'file-invalid-type') {
						showNotification('error', t('profile.typeAvatarError'));
					} else {
						showNotification('error', t('shared.somethingWentWrong'));
					}
				});
			});
			return;
		}

		const file = acceptedFiles[0];
		if (file) {
			try {
				await store.profile.uploadAvatar(file);
			} catch (e: any) {
				if (e?.errors) {
					const { errors } = e;
					Object.keys(errors).forEach((key) => {
						showNotification('error', errors[key]);
					});
				} else {
					showNotification('error', t('shared.somethingWentWrong'));
				}
			}
		}
	}, []);

	const onDragEnter = () => {
		setIsDragOver(true);
	};

	const onDragLeave = () => {
		setIsDragOver(false);
	};

	const { getRootProps, getInputProps } = useDropzone({
		accept: { 'image/*': [] },
		maxSize: MAX_FILE_SIZE * 1024 * 1024,
		onDrop,
		onDragEnter,
		onDragLeave,
	});

	return { getRootProps, getInputProps, isDragOver };
};
